import React, { useEffect, useState } from 'react'
import api from '../../api'
import no_image from '../../assets/images/no_image_listing.jpg'
import RenderPrice from '../common/RenderPrice'
import { IcBath, IcBed, IcGuest } from '../common/Icons'
import { getPropertyDetail } from '../../api/common'
import { useAppDispatch } from '../../redux/hooks'
import { setToastError } from '../../redux/slices/common'
import { setListingData } from '../../redux/slices/property'
import { VIEW } from '../../constant'
import CircularProgress from '@mui/material/CircularProgress'
import Tooltip from '@mui/material/Tooltip'

interface Props {
  hostId: string
  propertyId?: string
  updateView: (_v: string) => void
}

const Listing: React.FC<Props> = ({ hostId, propertyId, updateView }) => {
  const dispatch = useAppDispatch()
  const [properties, setProperties] = useState<any[]>([])
  const [loadingDetail, setLoadingDetail] = useState<any>({})

  useEffect(() => {
    async function fetchListing(hostId: string) {
      try {
        const res = await api.post('listing-service/v2/calendar/search', {
          hostAddress: hostId,
          pageSize: 1000,
        })
        setProperties(res.data)
      } catch (err) {
        console.log('--err--', err)
      }
    }

    if (hostId) {
      fetchListing(hostId)
    }
  }, [hostId])

  useEffect(() => {
    if (hostId && propertyId) {
      onClickListingItem(hostId, Number(propertyId))
    }
  }, [hostId, propertyId])

  const onClickListingItem = async (_hostId: string, _propertyId: number) => {
    try {
      setLoadingDetail({ [_propertyId]: true })
      const res = await getPropertyDetail(_hostId, _propertyId)
      dispatch(setListingData(res.data))
      updateView(VIEW.DETAIL)
    } catch (err: any) {
      dispatch(setToastError({ message: err.error.message }))
    } finally {
      setLoadingDetail({ [_propertyId]: false })
    }
  }

  return (
    <div className="dtrave-listing-container">
      {Array.isArray(properties) &&
        properties.map((item, index) => {
          return (
            <div
              key={item.id}
              className={'dtravel-relative'}
              onClick={() => onClickListingItem(hostId, item.id)}
              onKeyUp={() => onClickListingItem(hostId, item.id)}
              role={'button'}
              tabIndex={index}
            >
              {loadingDetail[item.id] && (
                <div
                  className="dtravel-CircularProgress"
                  style={{ zIndex: 9999 }}
                >
                  <CircularProgress size={30} style={{ color: '#0F0F0F' }} />
                </div>
              )}

              <div>
                <img
                  src={item.thumbnail || no_image}
                  alt={item.externalName}
                  className={'dtravel-object-cover dtravel-w-full dtravel-rounded-8'}
                  style={{ height: 122, minHeight: 122 }}
                />
              </div>
              <div className={'dtrave-listing-price-box dtravel-gap-8 dtravel-inter-500 dtravel-text-14-18 dtravel-neutral-800'}>
                <Tooltip title={item.externalName}>
                  <p className={'dtravel-flex-1 dtravel-line-clamp-1'}>{item.externalName}</p>
                </Tooltip>
                <p className={'dtravel-text-right'}>
                  <RenderPrice
                    price={item.propertyPrice.avgPrice || item.propertyPrice.basePrice}
                    currency={item.propertyPrice.currency}
                  />
                </p>
              </div>

              <div className={'dtravel-center-horizontal gap-[16px] mt-[8px]'}>
                <div className={'dtravel-center-horizontal dtravel-gap-8'}>
                  <IcGuest />
                  <span>{item.personCapacity}</span>
                </div>
                <div className={'dtravel-center-horizontal dtravel-gap-8'}>
                  <IcBed />
                  <span>{item.bedrooms}</span>
                </div>
                <div className={'dtravel-center-horizontal dtravel-gap-8'}>
                  <IcBath />
                  <span>{item.bathrooms}</span>
                </div>
              </div>
            </div>
          )
        })}
    </div>
  )
}

export default Listing
